import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgxPaginationModule} from 'ngx-pagination';

import { TestPageComponent } from './test-page.component';
import { TestPageService } from './test-page.service';

@NgModule({
  declarations: [
    TestPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    NgxPaginationModule
  ],
  providers: [TestPageService],
  bootstrap: [TestPageComponent]
})
export class TestPageModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/test-page/test-page.module.ts